<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <a-input v-model="query['item.no']" :placeholder="$t('placeholder.itemNo')" allowClear @pressEnter="search"/>
      <a-input v-model="query['item.name']" :placeholder="$t('placeholder.itemName')" allowClear @pressEnter="search"/>
      <a-input v-model="query['lot.no']" :placeholder="$t('placeholder.lotNo')" allowClear @pressEnter="search"/>
      <a-input v-model="query['location.no']" :placeholder="$t('placeholder.location')" allowClear @pressEnter="search"/>
      <a-date-picker v-model="query.dateFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('placeholder.startTime')" show-today valueFormat="YYYY-MM-DD"/>
      <a-date-picker v-model="query.dateFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('placeholder.endTime')" show-today valueFormat="YYYY-MM-DD"/>
      <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="search"/>
      <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      :column-config="{resizable: true}"
      :row-config="{isCurrent: true, isHover: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      :height="scrollY"
      size="mini"
      :scroll-x="{enabled: true}">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="maintenance.executed" title="business.label.executed" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="maintenance.important" title="business.label.important" width="70"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="lot.no" title="business.label.lotNo"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer"/>
      <vxe-column field="location.no" title="business.label.location"/>
      <vxe-column field="storageRoom.name" title="business.label.storageRoom"/>
      <vxe-column field="maintenance.inventoryQuantity" title="business.label.invQuantity"/>
      <vxe-column field="maintenance.quantity" title="span.maintenanceQuantity"/>
      <vxe-column field="maintenance.maintenanceWay" title="span.maintenanceMeasure">
        <template #default="{ row }">
          {{ row.maintenance.maintenanceWay === null || maintenanceWayData.length === 0 ? '' : maintenanceWayData.find(item => item.ordinal === row.maintenance.maintenanceWay).name }}
        </template>
      </vxe-column>
      <vxe-column field="maintenance.notes" title="span.maintenanceAdvice"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { findAll, findEnum } from '@/api/Api'
import moment from 'moment/moment'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'MaintenanceQuery',
    data() {
      return {
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.815),// 表格竖向滚动条
        data: [],
        maintenanceWayData: [],
        inventoryStateData: [],
        contentSize: 0,
        page: 1,
        size: 20,
        loading: false,
        query: {
          dateFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          },
          'item.no': '',
          'item.name': '',
          'lot.no': '',
          'location.no': ''
        }
      }
    },
    mounted() {
      findEnum('InventoryState').then(res => {
        if (res.success) {
          this.inventoryStateData = res.result
        }
      })
      findEnum('MaintenanceWay').then(res => {
        if (res.success) {
          this.maintenanceWayData = res.result
        }
      })
    },
    methods: {
      moment,
      disabledStartDate(startValue) {
        const endValue = this.query.dateFilter.end
        if (!startValue || !endValue) {
          return false
        }
        return new Date(startValue) > new Date(endValue)
      },
      disabledEndDate(endValue) {
        const startValue = this.query.dateFilter.start
        if (!endValue || !startValue) {
          return false
        }
        return new Date(startValue) >= new Date(endValue)
      },
      pageChange({currentPage, pageSize}) {
        this.page = currentPage
        this.size = pageSize
        this.getData()
      },
      getData() {
        this.loading = true
        findAll('maintenanceFactory', this.query, this.page, this.size).then(res => {
          if (res.success) {
            this.data = res.result
            this.contentSize = res.contentSize
          }
        }).finally(() => {
          this.loading = false
        })
      },
      search() {
        this.page = 1
        this.getData()
      },
      reset() {
        this.query = {
          dateFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          },
          'item.no': '',
          'item.name': '',
          'lot.no': '',
          'location.no': ''
        }
        this.getData()
      }
    }
  }
</script>
<style scoped lang="less">
  .query {
    width: 200px;
  }
</style>